import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Clock, X } from 'lucide-react';
import { useSubscription } from '../../context/SubscriptionContext';
import { useAuth } from '../../context/AuthContext';

const SubscriptionBanner: React.FC = () => {
  const { subscription, isGrace, daysRemaining } = useSubscription();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = React.useState(false);

  if (user?.role !== 'super_admin') return null;
  if (!subscription) return null;
  if (dismissed) return null;

  const isTrial = !!subscription.is_trial;
  const showBanner = isGrace || daysRemaining <= 7;
  if (!showBanner) return null;

  const isUrgent = isGrace || daysRemaining <= 3;

  return (
    <div className={`px-4 py-2.5 flex items-center justify-between text-sm ${
      isUrgent ? 'bg-red-500 text-white' : 'bg-amber-400 text-amber-900'
    }`}>
      <div className="flex items-center gap-2">
        {isUrgent ? <AlertTriangle size={16} /> : <Clock size={16} />}
        <span className="font-medium">
          {isGrace
            ? `⚠️ Grace period: ${subscription.grace_days_remaining} day(s) left to renew!`
            : isTrial
              ? `⏰ Free trial ends in ${daysRemaining} day(s). Subscribe to avoid interruption.`
              : `⏰ Subscription expires in ${daysRemaining} day(s). Renew to avoid interruption.`}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate('/subscription')}
          className={`text-xs font-semibold px-3 py-1 rounded-lg transition-all ${
            isUrgent ? 'bg-white text-red-600 hover:bg-red-50' : 'bg-amber-900/20 text-amber-900 hover:bg-amber-900/30'
          }`}
        >
          {isTrial ? 'Subscribe Now' : 'Renew Now'}
        </button>
        <button onClick={() => setDismissed(true)} className="opacity-70 hover:opacity-100">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBanner;